import type { ExpenseStatus } from '@/shared/domain'
import { Badge } from '@/shared/ui/primitives'

export type ExpenseStatusBadgeProps = {
  status: ExpenseStatus
  isDuplicateFlagged?: boolean
}

type BadgeMeta = {
  label: string
  variant: 'default' | 'secondary' | 'outline' | 'destructive'
}

const STATUS_META: Record<ExpenseStatus, BadgeMeta> = {
  pending: { label: 'Pending', variant: 'secondary' },
  approved: { label: 'Approved', variant: 'default' },
  denied: { label: 'Denied', variant: 'destructive' },
  withdrawn: { label: 'Withdrawn', variant: 'outline' },
}

export function ExpenseStatusBadge({ status, isDuplicateFlagged }: ExpenseStatusBadgeProps) {
  const meta = STATUS_META[status]

  return (
    <span className="inline-flex items-center gap-1.5">
      <Badge variant={meta.variant}>{meta.label}</Badge>
      {isDuplicateFlagged ? (
        <Badge variant="outline">Duplicate</Badge>
      ) : null}
    </span>
  )
}
